import { ICommonProductDetails } from "@/api/AppApi/services/product/interfaces/api-product-details-interface";
import ProductPriceInfo from "@/app/components/common-builder/product/product-box/product-box-helpers/product-price-info/ProductPriceInfo";
import SpecialPriceIcon from "./SpecialPriceIcon";

type TProps = {
  productSpecialPrice: ICommonProductDetails["selling_prices"];
};

const ProductDetailsPriceInfo: React.FC<TProps> = ({ productSpecialPrice }) => {
  return (
    <div className="product-details-price-info ">
      <div className="title">
        <SpecialPriceIcon />
        <p className="m-0">Special Prices:</p>
      </div>
      <ProductPriceInfo productSpecialPrices={productSpecialPrice} />
    </div>
  );
};

export default ProductDetailsPriceInfo;
